import { useMemo } from "react";
import { IStyleFunctionOrObject } from "@fluentui/merge-styles/lib/IStyleFunction";
import { IDetailsColumnStyleProps, IDetailsColumnStyles } from "@fluentui/react/lib/DetailsList";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

import { textOverflow } from "Utils/Styles";

const classNames = {
  host: `UserRendererHost`,
  root: `UserRenderer`
};

export function useUserRendererStyles(styles?: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles>) {
  const { fonts } = useTheme();

  const styleSet = useMemo(
    () => mergeStyleSets(
      {
        host: [classNames.host, {}],
        root: [
          classNames.root,
          {
            width: `100%`,
            ...textOverflow
          }
        ]
      },
      { host: styles }
    ),
    [styles]
  );

  const font = `${fonts.medium.fontSize} ${fonts.medium.fontFamily}`;

  return {
    styleSet,
    font
  };
}
